import React, { useState } from "react";
import { makeStyles } from "@material-ui/core";
import Typography from "../../molecules/Typography";
import Logo from "../../Logo";
import { URL_EBAY } from "../../../utils/config";
import CircularProgress from "../../molecules/CircularProgress";
import Button from "../../atoms/Button";
import { styleTemplates } from "../styles";

const useStyles = makeStyles((theme) =>
  styleTemplates(theme.palette.background.dark)
);

// eslint-disable-next-line import/no-anonymous-default-export
export default ({ setOpenAlert, setTextAlert }) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);

  const redirectToStoreEbay = async () => {
    setLoading(true);

    try {
      window.open(URL_EBAY, "_self");
    } catch (error) {
      setLoading(false);

      if (error.response && error.response.status === 401) {
        setOpenAlert(true);
        setTextAlert("El token ingresado es incorrecto, intenta nuevamente.");
      } else {
        setOpenAlert(true);
        setTextAlert("Error al generar la conexión, intenta nuevamente.");
      }
    }
  };

  return (
    <>
      <div sx={{ maxWidth: 345 }} className={classes.parentCard}>
        <div>
          <div
            style={{
              flexDirection: "row",
              justifyContent: "space-around",
              alignItems: "center",
              display: "flex",
              margin: "10px 0 20px 0",
            }}
          >
            <Logo />

            <Logo src="https://marketplaces-images.s3.us-west-2.amazonaws.com/Ebay/Logo_ebay.svg" />
          </div>
          <Typography
            gutterBottom={true}
            variant="body1"
            component={"div"}
            className={classes.titleStyle}
            message={"Conecta tu tienda eBay"}
          />
          <Typography
            gutterBottom={true}
            variant="body1"
            className={classes.letterColor}
            message={"1. Serás redireccionado a la tienda de eBay."}
          />
          <Typography
            gutterBottom={true}
            variant="body1"
            className={classes.letterColor}
            message={"2. Inicia sesión en eBay."}
          />
          <Typography
            gutterBottom={true}
            variant="body1"
            className={classes.letterColor}
            message={"3. Lee cuidadosamente las instrucciones."}
          />
          <Typography
            gutterBottom={true}
            variant="body1"
            className={classes.letterColor}
            message={"4. Acepta que Pakke pueda tener acceso a tu cuenta eBay."}
          />
        </div>

        <div className={classes.alignButton}>
          <Button
            onClick={redirectToStoreEbay}
            disabled={loading}
            variant="outlined"
            color="error"
            className={classes.button}
          >
            {loading && <CircularProgress size={14} />}
            {!loading && "Conectar mi tienda"}
          </Button>
        </div>
      </div>
    </>
  );
};
